import { useMemo } from "react";
import {
  AmbientLight,
  Box3,
  DirectionalLight,
  Group,
  Mesh,
  Object3D,
  OrthographicCamera,
  Vector3
} from "three";

import { SceneAndCamera } from "../SecondaryRenderer";

export function useModelScene(model: Object3D | null): SceneAndCamera {
  return useMemo(() => {
    if (!model) return { scene: null, camera: null };

    const viewDirection = new Vector3(1, 1, 1).normalize();
    const headlight = new DirectionalLight("#FFFFFF", 4);
    headlight.position.copy(viewDirection).add(new Vector3(-0.5, 0.3, -0.5));

    const scene = new Group().add(model, new AmbientLight(), headlight);
    const camera = new OrthographicCamera();

    fitCameraToModel(camera, model, viewDirection);

    return { scene, camera };
  }, [model]);
}

function fitCameraToModel(
  camera: OrthographicCamera,
  model: Object3D,
  viewDirection: Vector3
) {
  const center = new Box3().setFromObject(model).getCenter(new Vector3());
  const radius = farthestVertexDistance(model, center);
  camera.left = camera.bottom = -radius;
  camera.right = camera.top = radius;
  camera.near = 0;
  camera.far = radius * 4;
  camera.position.copy(center).addScaledVector(viewDirection, radius * 2);
  camera.lookAt(center);
  camera.updateProjectionMatrix();
}

// NOTE: not too sure how this works, this was AI assisted bcs I couldnt solve a bug
function farthestVertexDistance(model: Object3D, center: Vector3): number {
  model.updateMatrixWorld(true);
  const vertex = new Vector3();
  let farthest = 0;
  model.traverse((object) => {
    if (!(object instanceof Mesh)) return;
    const position = object.geometry.getAttribute("position");
    for (let i = 0; i < position.count; i++) {
      vertex.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
      farthest = Math.max(farthest, vertex.distanceTo(center));
    }
  });
  return farthest;
}
